import { Outlet } from "react-router-dom";

// Shell for /integrations/*. Flex row so the GitHub section can place its sidebar
// next to the content (same pattern as ProjectLayout); other pages just fill it.
const IntegrationLayout = () => {
  return (
    <div className="flex flex-1 min-w-0 overflow-auto relative">
      <Outlet />
    </div>
  );
};

export default IntegrationLayout;
